/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FoldersPaginationWrapper_viewer$ref = any;
type FoldersRefetchWrapper_viewer$ref = any;
type Recommendations_trending$ref = any;
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type FoldersContainer_viewer$ref = any;
export type FoldersContainer_viewer = {
    readonly user?: {
        readonly serviceId: string | null;
        readonly isVerifiedTrade: boolean | null;
        readonly profile: {
            readonly currency: Currency | null;
        } | null;
    } | null;
    readonly " $fragmentRefs": Recommendations_trending$ref & FoldersRefetchWrapper_viewer$ref & FoldersPaginationWrapper_viewer$ref;
    readonly " $refType": FoldersContainer_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "FoldersContainer_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "Recommendations_trending",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "user",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "userId",
                            "variableName": "userId"
                        }
                    ],
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isVerifiedTrade",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "profile",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Profile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "currency",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "FoldersRefetchWrapper_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "FoldersPaginationWrapper_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '7aaebba603e1da2b855267a0f0d73cc5';
export default node;
